import AppLayout from "@/components/layout/AppLayout";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { User, Settings as SettingsIcon } from "lucide-react";
import { AccountSettings } from "./settings/components/AccountSettings";

const GuardProfile = () => {
  return (
    <AppLayout>
      <div className="min-h-screen bg-gradient-to-br from-background via-background to-muted/20 relative overflow-hidden">
        {/* Background patterns */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/3 via-transparent to-blue-500/3 pointer-events-none"></div>
        <div className="absolute top-20 right-10 w-96 h-96 bg-gradient-radial from-blue-500/8 to-transparent rounded-full blur-3xl pointer-events-none animate-pulse"></div>
        <div className="absolute bottom-20 left-10 w-96 h-96 bg-gradient-radial from-primary/8 to-transparent rounded-full blur-3xl pointer-events-none animate-pulse" style={{ animationDelay: '2s' }}></div>
        
        <div className="relative z-10 container py-6 md:py-10 max-w-5xl">
          {/* Header Section */}
          <div className="mb-12 text-center relative animate-fade-in">
            <div className="absolute inset-0 bg-gradient-to-r from-primary/10 via-blue-500/10 to-purple-500/10 rounded-3xl blur-3xl"></div>
            <div className="relative">
              <div className="flex items-center justify-center mb-6">
                <div className="p-4 bg-gradient-to-br from-primary to-primary/80 rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
                  <User className="h-10 w-10 text-white" />
                </div>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold bg-gradient-to-r from-foreground via-primary to-blue-600 bg-clip-text text-transparent mb-4 tracking-tight">
                My Profile
              </h1>
              <p className="text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
                Manage your personal information and preferences
              </p>
              <div className="mt-6 flex justify-center">
                <div className="h-1 w-20 bg-gradient-to-r from-primary to-blue-500 rounded-full"></div>
              </div>
            </div>
          </div>
          
          {/* Profile Content */}
          <Card className="border-0 shadow-2xl bg-card/95 backdrop-blur-lg hover:shadow-3xl transition-all duration-500 relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-blue-500/5 pointer-events-none"></div>
            <CardHeader className="relative">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-gradient-to-br from-primary/10 to-blue-500/10 rounded-xl">
                  <SettingsIcon className="h-5 w-5 text-primary" />
                </div>
                <div>
                  <CardTitle className="text-2xl">Profile Settings</CardTitle>
                  <CardDescription className="text-base">
                    Update your profile information and contact details
                  </CardDescription>
                </div>
              </div>
            </CardHeader>
            <CardContent className="p-8 relative">
              <div className="animate-fade-in">
                <AccountSettings />
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </AppLayout>
  );
};

export default GuardProfile;
